var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66667C13.3333 5.19391 14.5272 4 15.9999 4C17.4727 4 18.6666 5.19391 18.6666 6.66667C21.7868 8.14207 23.8381 11.219 23.9999 14.6667V18.6667C24.2034 20.3477 25.1931 21.8323 26.6666 22.6667H5.33325C6.80674 21.8323 7.79643 20.3477 7.99992 18.6667V14.6667C8.16174 11.219 10.213 8.14207 13.3333 6.66667",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.667V24.0003C12 26.2095 13.7909 28.0003 16 28.0003C18.2091 28.0003 20 26.2095 20 24.0003V22.667",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.a7c7c035168afb1b49b80ab19bde856e.svg";
export { ForwardRef as ReactComponent };